import React, { useEffect } from "react";
import { useI18n } from "../i18n";

export default function SEO({ title, description, path = "/", image, type = "website", noindex = false }) {
  const { lang } = useI18n();
  const domain = "https://altamiravenezuela.com";
  const url = `${domain}${path}`;
  const t = typeof title === "object" ? title[lang] || title.es : title;
  const d = typeof description === "object" ? description[lang] || description.es : description;
  const img = image || `${domain}/og-image.jpg`;

  useEffect(() => {
    document.title = t ? `${t} | Grupo Inversiones Altamira` : "Grupo Inversiones Altamira";
    setMeta("description", d);
    setMeta("og:title", t, true);
    setMeta("og:description", d, true);
    setMeta("og:url", url, true);
    setMeta("og:type", type, true);
    setMeta("og:image", img, true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", t);
    setMeta("twitter:description", d);
    setMeta("twitter:image", img);
    setLink("canonical", url);
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    setLink("alternate", url, { hreflang: "es" });
    setLink("alternate", url, { hreflang: "en" });
    setLink("alternate", url, { hreflang: "x-default" });
  }, [t, d, url, type, img]);

  return null;
}

function setMeta(name, content, isProp = false) {
  if (!content) return;
  const attr = isProp ? "property" : "name";
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) { tag = document.createElement("meta"); tag.setAttribute(attr, name); document.head.appendChild(tag); }
  tag.setAttribute("content", content);
}
function setLink(rel, href, extra = {}) {
  const selector = extra.hreflang ? `link[rel="${rel}"][hreflang="${extra.hreflang}"]` : `link[rel="${rel}"]`;
  let tag = document.head.querySelector(selector);
  if (!tag) { tag = document.createElement("link"); tag.setAttribute("rel", rel); document.head.appendChild(tag); }
  tag.setAttribute("href", href);
  Object.entries(extra).forEach(([k, v]) => tag.setAttribute(k, v));
}

export function JsonLd({ data }) {
  useEffect(() => {
    const id = "jsonld-" + (data["@type"] || "page");
    let s = document.getElementById(id);
    if (!s) { s = document.createElement("script"); s.type = "application/ld+json"; s.id = id; document.head.appendChild(s); }
    s.textContent = JSON.stringify(data);
    return () => { if (s) s.remove(); };
  }, [data]);
  return null;
}
